import React, { useState, useEffect } from "react";
import "./layout.css";
import Sidebar from "../sidebar/Sidebar";
import TopNav from "../topnav/TopNav";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { createTheme } from "@mui/material";

const theme = createTheme();

const drawerWidth = 270;
const collapsedDrawerWidth = 70;

const useStyles = makeStyles({
  Content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  contentCollapsed: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: collapsedDrawerWidth,
  },
});

const Layout = ({ children }) => {
  const location = useLocation();
  const classes = useStyles();

  const [open, setOpen] = useState(() => {
    const v = localStorage.getItem("sidebarOpen");
    return v !== null ? v === "true" : window.innerWidth > 768;
  });
  const [collapsed, setCollapsed] = useState(() => {
    const v = localStorage.getItem("sidebarCollapsed");
    return v !== null ? v === "true" : true;
  });

  useEffect(() => {
    localStorage.setItem("sidebarOpen", String(open));
  }, [open]);

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", String(collapsed));
  }, [collapsed]);

  const handleDrawerToggle = () => {
    if (window.innerWidth > 768) {
      setCollapsed((c) => !c);
    } else {
      setOpen((o) => !o);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleResize = () => {
    setOpen(window.innerWidth > 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const body = document.body;

    if (window.innerWidth > 768) {
      if (collapsed) {
        body.classList.remove("sidebar-expanded");
        body.classList.add("sidebar-collapsed");
      } else {
        body.classList.remove("sidebar-collapsed");
        body.classList.add("sidebar-expanded");
      }
    } else {
      body.classList.remove("sidebar-collapsed", "sidebar-expanded");
    }

    return () => {
      body.classList.remove("sidebar-collapsed", "sidebar-expanded");
    };
  }, [collapsed, open]);

  return (
    <div className={`layout `}>
      <Sidebar
        open={open}
        setOpen={setOpen}
        collapsed={collapsed}
        location={location}
        handleClose={handleClose}
      />
      <div
        className={clsx(classes.Content, {
          [classes.contentShift]: open && !collapsed,
          [classes.contentCollapsed]: open && collapsed,
        })}
      >
        <div className="layout__content">
          <TopNav
            handleDrawerToggle={handleDrawerToggle}
            sidebarOpen={open}
            collapsed={collapsed}
          />
          <div className="layout__content-main">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
